<template>
 <section class="container list-page" style="max-width:1000px">
    <!-- <div style="text-align:center"> -->
        <!-- <a>Link</a> -->
        <Breadcrumb 
            :levelTwoText = "'Routes'"
        />
        <Heading 
            :heading = "'Explore Routes'"
        />
     
        <!-- <div class="columns is-variable is-multiline is-6-mobile"> -->
            <!-- <div class="column is-full-desktop is-6-mobile"> -->
                <RadioFilter 
                    v-on:selection-change="updateSelectedContinent"
                    :options = "$continentsArray"
                    :type = "'Continent'"
                    :label="'Continent'"
                />
            <!-- </div> -->
        <!-- </div> -->

        <div class="spacer" style="height:30px"></div>
        
        <!-- <div class="columns is-variable is-multiline  is-6-mobile"> -->
            <!-- <div class="column is-full-desktop is-6-mobile"> -->
                <RadioFilter 
                    v-on:selection-change="updateSelectedTag"
                    :options = "['touring','bikepacking', 'gravel', 'singletrack', 'bikepath', 'road' ]"
                    :type = "'route-tags'"
                    :label = "'Style'"
                />
            <!-- </div> -->
        <!-- </div> -->

        <div class="spacer" style="height:30px"></div>
        <div class="small-label">Name</div>
        <div style="max-width:350px; margin-left:auto; margin-right:auto">
            <b-field>
                <b-input v-model="filterInput" placeholder='Route name' style="text-align:center"></b-input>
            </b-field>
        </div>
        <div class="spacer" style="height:60px"></div>

        <div class="block is-size-7" style="text-align:left; margin-bottom:5px">
            <!-- <span class="title is-size-6">Order By: </span> -->
            <b-radio v-model="orderby"
                native-value="posts"
                type="is-info is-light">
                <span>Post Count</span>
            </b-radio>

            <b-radio v-model="orderby"
                native-value="name"
                type="is-info is-light is-outlined is-small">
                <span>Alphabetical</span>
            </b-radio>
        </div>
            <!-- </div> -->
            

        

        <!-- </div> -->

        
        <div v-if="routesData.length > 0">
            <ul >
                <li  class="list-link" v-for="routeObj in sortedRoutes" v-bind:key="routeObj.display_name">
                    <RouteRow 
                        v-bind:routeObj = "routeObj"
                        v-if = "( (routeObj.continent && routeObj.continent.includes(selectedContinent)) || selectedContinent == 'All') 
                        && ( filterInput != '' && getDisplayText(routeObj.display_name).toLowerCase().includes(filterInput.toLowerCase()) || filterInput == ''  ) && matchesTag(routeObj, selectedTag)"
                    />
                </li>
            </ul>
        </div>

        <div class="section card" ref="results" v-if="isLoading">
            <b-icon class="fas fa-spinner fa-spin"></b-icon>
            Loading...
        </div>

        <div class="spacer" style="height:60px"></div>      
        <b-button v-if="routesData.length > 0" v-scroll-to="'#app'" class="is-large">Scroll to top</b-button>  
        <div class="spacer" style="height:100px"></div>  
    <!-- </div> -->
    </section>
</template>

<script>
import RouteRow from '@/components/RouteRow';
import Heading from '@/components/Heading';
import ContinentFilter from '@/components/ContinentFilter';
import RadioFilter from '@/components/RadioFilter';
import Breadcrumb from '@/components/Breadcrumb';
export default {
  name: 'Routes',
  components: { RouteRow, Heading, ContinentFilter, RadioFilter, Breadcrumb },
  
  data () {
    return {
        routesData: [],
        orderby: 'posts',
        isLoading: false,
        filterInput: "",
        selectedContinent: "",
        selectedTag: 'All',
        displayTextMap: { Transamerica: "TransAmerica" , 'Pan-american Highway': "Pan-American Highway"} // copied from findTrip
    }
  },
  computed: {
    sortedRoutes() {
        if (this.orderby == 'posts') {
            return [...this.routesData].sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
        } else {
            return [...this.routesData].sort((a, b) => (a.display_name > b.display_name) ? 1 : -1);
        }
    }
  },
  methods: {
      updateSelectedTag(tag) {
          this.selectedTag = tag;
      },
      matchesTag(route, tag) {
        if (!tag || tag == '' || tag == 'All') {
            return true;
        } else if (route && tag) {
            // if (tag == 'around the world' || tag == 'retired' || tag == 'solo female' || tag == 'solo male' || tag == 'couple' || tag =='middle aged') {
                // console.log(book.ridertags, tag);
            if (route[tag]) {
                return true;
            }
            // } else if (tag == 'bikepacking' || tag == 'racing' || tag == 'Audible') {
                // console.log(book[tag]);
                // if (book[tag.toLowerCase()]) {
                //     return true;
                // }
            // } else {
            //     return false;
            // }
        } else {
            return true;
        }
        return false;
        
          
      },
      updateSelectedContinent(newContinent) {
          this.selectedContinent = newContinent;
      },

      getRoutes() {
        console.log("Getting route data");
        this.routesData = [];
        // var result = [];
        var that = this;
        var pageCountData = {};
        var routesMetadata = [];
        this.isLoading = true;
        // first get routes page counts
        this.$db.collection("page_counts").doc('routes').get()
        .then(function(doc) {
            if (doc.exists) {
                var temp = {};
                temp[doc.id] = doc.data();
                pageCountData = temp.routes;
                // then get routes metadata
                var that2 = that;
                that.$db.collection("routes").get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        routesMetadata.push(doc.data());
                    });

                    // then merge the two
                    for (var i = 0; i < routesMetadata.length; i++) {
                        var displayName = routesMetadata[i].display_name;
                        if (displayName in pageCountData) {
                            var newobj = routesMetadata[i];
                            newobj.post_count = pageCountData[displayName].post_count;
                            that.routesData.push(newobj);
                        }
                    }
                    // console.log(that.routesData);
                    
                    that.routesData.sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
                    that.isLoading = false;

                });
            } else {
                console.log("ERROR: Can't fetch links by type", that.type);
                that.isLoading = false;
            }

        })
        .catch(function(error) {
            console.log("Error getting links by type: ", error);
            that.isLoading = false;
        });
        

    },
    // getImage(routeName) {
    //     var images = [];
    //     this.$db.collection("pages").where("routes", "array-contains", routeName).limit(3).get()
    //     .then((querySnapshot) => {
    //         querySnapshot.forEach((doc) => {
    //             // doc.data() is never undefined for query doc snapshots
    //             // console.log(doc.data().image);
    //             images.push(doc.data().image);
    //         });
    //     })
    //     .catch((error) => {
    //         console.log("Error getting documents: ", error);
    //     });
    //     return images[0];

    // },
    displayRoutesData(orderby) {
        if (this.orderby == 'posts') {
            return this.routesData.sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
        } else {
            return this.routesData.sort((a, b) => (a.display_name > b.display_name) ? -1 : 1);
        }
    },
    getDisplayText(val) {
        if (this.displayTextMap[val]) {
            return this.displayTextMap[val];
        } else {
            return val;
        }

    },

  },
  metaInfo() {
        var title =  'Routes: Bikepacking and Touring Routes From All Around the World';
        var description = "Find your next bike adventure route on any continent, any terrain, any style.";
        return {
            title: title,
            titleTemplate: this.$titleTemplate,
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    },
  mounted() {
      this.getRoutes();
      this.selectedContinent = "All";
      this.orderby = "posts";
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Routes.vue